import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BaseApiService, DynamicsApiService } from '../api';
import { CrmServiceInterface } from './interface';
import { ExportTypeEnum } from '../../enums';
import { AbstractCrmService } from './abstract-crm-service';
import { MappingFieldsRequestParamDto } from '../../dto';

@Injectable({
  providedIn: 'root',
})
export class DynamicsService extends AbstractCrmService implements CrmServiceInterface<any> {

  constructor(
    readonly baseApiService: BaseApiService,
    private readonly dynamicsApiService: DynamicsApiService,
  ) {
    super(baseApiService);
  }

  getExportType(): ExportTypeEnum {
    return ExportTypeEnum.DYNAMICS;
  }

  authenticate(code: string, param?: any): Observable<any> {
    return this.dynamicsApiService.authenticate(code);
  }

  logout(): any {
    return this.dynamicsApiService.logout();
  }

  getSettings(): Observable<any> {
    return this.dynamicsApiService.getSettings();
  }

  getMappingFields(params: MappingFieldsRequestParamDto = {}): Observable<any> {
    return this.dynamicsApiService.getMappingFields(params);
  }

  setSettings(settings: any): Observable<any> {
    return this.dynamicsApiService.updateSettings(settings);
  }
}
